<template>
  <v-container class="ma-0">
     
  <template>
        <v-card class="ma-2 justify-center">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Επισκευές</h1>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer/>
            <v-select
                v-model="filterYear"
                :items="uniqueRepairYears"
                label="Έτος χρήσης"
                prepend-icon="mdi-calendar"
                :suffix="fiDate"
                clearable
              ></v-select>
            <v-spacer/>
            
          <v-menu
      top
      close-on-click
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Εξαγωγη
        </v-btn>
      </template>

      <v-list>
        <v-list-item>
         <v-btn text
            @click="exportRepairsQ"
          >Εξαγωγη ως προσφορά
          </v-btn>
          </v-list-item>
          <v-list-item>
          <v-btn text
            @click="exportRepairsP"
          >Εξαγωγη επισκευων
          <v-icon>mdi-file-pdf-box</v-icon>
          </v-btn>
        </v-list-item>
          <v-list-item>
          <v-btn text
            @click="exportRepairsD"
          >Εξαγωγη επισκευων
          <v-icon>mdi-file-word-box</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
          
          
            <v-spacer/>
               <v-switch
                  v-model="onlyDue"
                  label="Μόνο εκκρεμεί"
                ></v-switch>
                <v-spacer/>
                <v-switch
                  v-model="showProfit"
                  label="Κέρδος"
                ></v-switch>
          </v-card-title>
          <v-card-text>
          <balance-row
           :transactions="transactions"
           :charge="repairsCost"
           :debit="tabTotal"
           :balance="repairBalance"/> 
          </v-card-text>
          
          <v-data-table :headers="showHeaders" :items="repairsF"
          sort-by='Date'
          multi-sort
          sort-desc
          :search="search"
          loading: false
          item-key="Id"
          class="elevation-1"
          :items-per-page=15
          :height="$vuetify.breakpoint.height*0.6"
          :loading="loading" loading-text="Loading... Please wait"
          show-select
          @item-selected="itemSelected"
          @toggle-select-all="itemSelectAll"
>
             
      
          <template v-slot:item.Vehicle.VehType="{ item }">
            <span v-if="!item.Vehicle.VehType">-</span>
            <span v-else>
             <v-icon>{{$vehicleBadges[item.Vehicle.VehType]}}</v-icon>
             <span v-if="$vuetify.breakpoint.mdAndUp">  {{ item.Vehicle.VehType }}</span>
            </span>
          </template>
           <template v-slot:item.RepairCost="{ item }">
            {{ $tocurr(item.RepairCost) }}
          </template>
            <template v-slot:item.Profit="{ item }">
            <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                          {{ (item.Profit/item.RepairCost*100).toFixed(2) }} %
                          </span>
                        </template>
                        <span>{{ $tocurr(item.Profit) }}</span>
                      </v-tooltip>
            
          </template>
           <template v-slot:item.RepairDue="{ item }">
            {{ $tocurr(item.RepairDue) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="showHeaders.length">More info about {{ item.Id }}</td>
            {{ item.Notes }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
              :to="{name: 'edit-repair', params: {repairId: item.Id}}"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              @click="invoice(item.Id)">
              <v-icon dark>mdi-printer-pos</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              @click="payoff(item.Id)">
              <v-icon dark>mdi-receipt-text-check</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              v-if="item.QuoteId"
              :to="{name: 'quote-edit', params: {quoteid: item.QuoteId}}">
              <v-icon dark>mdi-text-box</v-icon>
            </v-btn>
            <new-repair :VehId="item.Id" useIcon="true"/>
            
          </template>
        <template v-slot:no-data>
          <span>Δεν υπάρχουν επισκεύες οχημάτων για τον πελάτη</span>
        </template>
        
          <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div v-if="header.value == 'profit'">
                    {{ tocurr(partsProfit) }}
                </div>
                <div class="text-right" v-if="header.value == 'qty'">
                  {{ partsQty}}
                </div>
                <div class="text-right" v-if="header.value == 'description'">
                  Σύνολο:
                </div>

                <div v-if="header.value == 'RepairCost'">
                    {{ tocurr(repairsTotalCost) }}
                </div>
                
                <div v-if="header.value == 'RepairDue'">
                   {{ tocurr(repairsTotalDue) }}
                </div>
                  <div v-if="header.value == 'Profit'">
                   
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                          {{ tocurr(repairsTotalProfit) }}
                          </span>
                        </template>
                        <span>{{ (repairsTotalProfit/repairsTotalCost*100).toFixed(2) }} %</span>
                      </v-tooltip>
                   
                   
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>
        
        </v-data-table>
        </v-card>
      </template>
</v-container>

</template>

<script>
import {sumBy as _sumBy} from "lodash";
import NewRepair from "../../components/NewRepair.vue";
import BalanceRow from "../../components/BalanceRow.vue";

export default {
  components: {
     NewRepair,
     BalanceRow,
  },
  computed: {
    transactions () {
        return this.repairs.length;
    },
    repairsF () {
        if (this.filterYear) return this.repairs.filter((e) => e.Date.slice(0,4) == this.filterYear);
        return this.repairs;
    },
    repairsCost () {
       return _sumBy(this.repairsF, 'RepairDue') + _sumBy(this.repairsF, 'RepairPaid');
    },
    tabTotal () {
     if (this.filterYear) return _sumBy(this.tabDebits.filter((e) => e.Date.slice(0,4) == this.filterYear), 'TotalValue');
        return _sumBy(this.tabDebits, 'TotalValue');
    },
    fiDate() {
      if (!this.filterYear) return;
      return this.tocurr(this.repairsF.reduce((a, b) => a + (b.RepairCost|| 0), 0))
    },
    uniqueRepairYears () {
      // console.log("asdsd: ", this.uniq(this.repairs, "Date"));
      return this.uniqYears(this.repairs);
    },
    repairsTotalCost () {
        if (this.onlyDue) return this.repairsF.filter(e=>e.RepairDue>0).reduce((a, b) => a + (b.RepairCost|| 0), 0);
        return this.repairsF.reduce((a, b) => a + (b.RepairCost|| 0), 0);
    },
    repairsTotalDue () {
        return this.repairsF.reduce((a, b) => a + (b.RepairDue|| 0), 0);
    },
    repairsTotalProfit () {
        if (this.onlyDue) return this.repairsF.filter(e=>e.RepairDue>0).reduce((a, b) => a + (b.Profit|| 0), 0);
        return this.repairsF.reduce((a, b) => a + (b.Profit|| 0), 0);
    },
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["Id","Vehicle.Vin",]).includes(h.value));
        } else if (!this.showProfit) {
            return this.headers.filter(h => !(["Profit"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
  },  
  data() {
    return {
      expanded: [],
      filterYear: '',
      vehicleMake: [],
      loading: true,
      search: '',
      customer: null,
      customer_id: this.$route.params.id,
      vehicle: '',
      repairBalance: 0,
      tabDebits: [],
      showFilters: false,
      repairs: [],
      toExport: [],
      onlyDue: false,
      showProfit: false,
       headers: [
        {
          text: "Α/A",
          align: "start",
          //sortable: false,
          value: "Id",
          width: "5%",
        },
        { text: 'Ημ/νία', value: 'Date'},
        {
          text: "Αρ. Κυκλοφορίας",
          align: "start",
          //sortable: false,
          value: "Vehicle.PlateNumber",
          width: "10%",
        },
        { text: "VIN", value: "Vehicle.Vin" },
        { text: "Τύπος", value: "Vehicle.VehType"},
        { text: "Αξία", value: "RepairCost" },
        { text: "Υπόλοιπο", value: "RepairDue",
            filter: (value) => {
            if (!this.onlyDue) return true;
            return value > 0;
            },
        },
        { text: "Κέρδος", value: "Profit" },
        { text: "Actions", value: "actions", sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/repairs/customers/'+this.$route.params.id);
        this.repairs = response.data;
        const resp = await this.$api.get('/customers/'+this.$route.params.id);
        this.customer = resp.data;
        this.repairBalance = this.customer.RepairBalance;
        this.tabDebits = this.customer.TabDebits;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  async exportRepairsQ() {
      this.exportRepairs(false, true);
  },
    async exportRepairsD() {
      this.exportRepairs(false, false);
  },
    async exportRepairsP() {
      this.exportRepairs(true, false);
  },
  
    async exportRepairs(aspdf, asquote) {
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/json;charset=utf-8' },
          params: {pdf: aspdf, quote: asquote},
          data:  this.toExport, //this.repairs.map(e=>e.Id),
          url: '/repairs/cards',
          responseType: "blob",
        };
    
    
          this.$api(options).then((response) => {
          let url = window['URL'].createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = "export.zip";
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
        })
        .then(() => {
          // alert('File saved succesfully');
        })
        .catch((error) => {
          console.log(error);
        });
        
    },
    async invoice (repair) {
        const response = await this.$api.patch("/repairs/invoice/"+repair);
        if (response.status == 202) {
        alert("Invoiced");
        }
    },
    async payoff (repair) {
        const response = await this.$api.patch("/repairs/payoff/"+repair);
        if (response.status == 202) {
        alert("Paid");
        }
    },
    itemSelected(selected) {
    if (selected.value) {
      this.toExport.push(selected.item.Id);
    } else {
      const index = this.toExport.indexOf(selected.item.Id);

        this.toExport.splice(index, 1);
    }
  },
  itemSelectAll(selected) {
    if (selected.value) {
      for (let item of selected.items) {
        this.toExport.push(item.Id);
      }
    } else {
      this.toExport = []
    }
  },
   uniqYears(items) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      let year = 0;
      for (let val of items) {
        year = val['Date'].slice(0,4);
        //console.log(year) //.getFullYear();
        //If item is already added then move to the next item
        if (itemsFound[val[year]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(year);

        //Mark it as added
        itemsFound[year] = true;
      }

      //Return the uniques
      return uniques;
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },

  }
}
</script>
